const ROUTES = {
  verses: "/verses",
  contentManagment: "/content-managment",
  userManagment: "/user-managment",
  templates: "/templates",
  settings: "/settings",
};

export default ROUTES;
